import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
interface IKeywordsList extends ITableCellProps {
    getLink?: (value: string) => string;
}

export const KeywordsList: FC<IKeywordsList> = ({ row, field, getLink, showTotalCount }) => {
    const { [field]: words = [] } = row;
    if (words[0] === "grid.upgrade" || words.length === 0) {
        return null;
    } else {
        return (
            <div className="keywords-container">
                {showTotalCount ? <b>{`${words.length} keywords:`}</b> : null}
                {getLink
                    ? words
                          .map((word: string) => {
                              return (
                                  <a
                                      key={word}
                                      href={getLink(word)}
                                  >
                                      {word}
                                  </a>
                              );
                          })
                          .reduce((prev: FixmeType, curr: FixmeType) => [prev, " | ", curr])
                    : words.join(" | ")}
            </div>
        );
    }
};
KeywordsList.displayName = "KeywordsList";
